module.exports = __webpack_public_path__ + "static/陈振华-2020年度智慧餐饮风云人物奖-9426b759f80a18aea2a0568a43dd8322.jpg";